module.exports = __webpack_public_path__ + "static/youtube_logo-d4824662563371d1cae1525053d3b67f.png";